
module.exports = {
    title1:'Yeahgrowth ',
    title2:'一站式广告',
    title3:'精细化管理平台',
    discribe1:'我们拥有智能化的数据监控、',
    discribe2:'可视化的广告管理、',
    discribe3:'透明化的流量投放、',
    discribe4:'定制化的市场洞察以及独立化的权限管理。',
    help1:'我们如何',
    help2:'帮助',
    help3:'您',
    helpdis:'依托Yeamobi强大的AI数据分析能力与丰富的广告投放运营经验，我们可以构建全链路精细化管理体系，提供给广告主集程序化流量等多种媒体流量，帮助企业有效提升广告投放效率，快速实现广告投放效果最大化。',
    introduce:'我们将展示给您最专业的媒体资源介绍。',
    introduce2:'一切将从这里开始。',
    goal:'目标达成，即刻开始!',
    views:'立即查看',
    source:'媒体资源',
    by:'',
    lookmore:'查看更多',
    forward:'敬请期待',
    updated:'内容正在持续开发中'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/channelPage/zh-cn.js